<template>
  <div class="mt-2 dir-container">
    <div v-if="isLoading">Loading...</div>
    <RecursiveDirectoryTree
      v-else
      v-for="dir in directoryTree"
      :directory="dir"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecursiveDirectoryTree from "@/components/ScenarioDirectoryTree/RecursiveDirectoryTree";

export default {
  name: "ScenarioDirectoryTreeContainer",
  components: { RecursiveDirectoryTree },
  props: ["isActive"],
  mounted() {
    this.$store.dispatch("scenarioDirectoriesStore/loadDirectoryTree");
  },
  computed: {
    ...mapGetters("scenarioDirectoriesStore", ["directoryTree", "isLoading"]),
  },
};
</script>

<style scoped>
.dir-container {
  margin-left: -28px;
}
</style>
